// extracted by mini-css-extract-plugin
module.exports = {"slice":"SliceMachine_slice__lz0sH","sliceFull":"SliceMachine_sliceFull__bLs9p","sliceTint":"SliceMachine_sliceTint__3DuMQ"};